import { createSlice } from "@reduxjs/toolkit";
import { IStudentTransactionDetailSlice } from "../../../models/student/studentAccountsDetails";

const InitialStudentTransactionDetails: IStudentTransactionDetailSlice = {
  TransactionDetail: undefined,
};

const studentTransactionsSlice = createSlice({
  name: "TransactionDetail",
  initialState: InitialStudentTransactionDetails,
  reducers: {
    setStudentTransactionInfo: (state, action: { payload: any }) => {
      state.TransactionDetail = action.payload;
    },
  },
});

export const { setStudentTransactionInfo } = studentTransactionsSlice.actions;

const studentTransactionReducer = studentTransactionsSlice.reducer;

export type studentTransactionState = ReturnType<typeof studentTransactionReducer>;

export default studentTransactionReducer;
